import { CSSProperties, FC, PropsWithChildren } from 'react';

import { IonCardContent } from '@ionic/react';
import { useTheme } from 'styled-components';
import classNames from 'classnames';

import styles from './CardContent.module.scss';

type CardContentProps = PropsWithChildren<{
  truncate?: number;
  className?: string;
  whiteSpace?: CSSProperties['whiteSpace'];
}>;

export const CardContent: FC<CardContentProps> = ({
  children,
  truncate,
  className,
  whiteSpace,
}) => {
  const { fontSize } = useTheme();

  return (
    <IonCardContent className={classNames(styles.root, className)}>
      <div
        className={classNames(styles.content, {
          [styles.truncate]: !!truncate,
        })}
        style={{
          whiteSpace,
          fontSize: fontSize(16),
          lineHeight: fontSize(20),
          WebkitLineClamp: truncate,
        }}
      >
        {children}
      </div>
    </IonCardContent>
  );
};
